import { cloneDeep } from "lodash-es";
import React, { useState } from "react";
import { Form } from "react-final-form";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../components/DetailedErrorAlert";
import { adminApi as api, extractErrorMessage } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { CptCodeListPriceForm } from "./CptCodeListPriceForm";

export const CreateLabCptCodeListPriceModal = ({ labId, onCreate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen(!open);

  const handleCreate = async (values) => {
    const newValues = cloneDeep(values);

    setError(null);
    try {
      const res = await api.post("/admin/lab_cpt_code_list_prices", { lab_cpt_code_list_price: snakifyKeys(newValues) });

      if (onCreate) {
        onCreate(res.data.resource);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Add CPT Code List Price
      </Button>

      <Modal isOpen={open} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>Add CPT Fee Schedule By Payor</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleCreate} initialValues={{ labId }}>
            {(props) => <CptCodeListPriceForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
